var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 2,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 21.5,
    height: 21.5,
    rx: 1.75,
    stroke: "black",
    strokeOpacity: 0.25,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeDasharray: "2 2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.616 6.41133C15.0679 5.86328 14.1916 5.86328 13.6982 6.41133L11.0137 9.09583L8.32887 6.41104C7.78082 5.86299 6.90444 5.86299 6.41104 6.41104C5.86299 6.95909 5.86299 7.83547 6.41104 8.32887L9.09583 11.0137L6.41104 13.6985C5.86299 14.2465 5.86299 15.1229 6.41104 15.6163C6.68507 15.8903 7.01375 16 7.39706 16C7.78077 16 8.10944 15.8903 8.38308 15.6163L11.0679 12.9315L13.7527 15.6163C14.0267 15.8903 14.3554 16 14.7387 16C15.1224 16 15.4511 15.8903 15.7247 15.6163C16.2727 15.0682 16.2727 14.1919 15.7247 13.6985L12.9313 11.0137L15.6161 8.32887C16.1638 7.7812 16.164 6.90434 15.616 6.41133Z",
    fill: "#E93445",
    stroke: "white",
    strokeWidth: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFail);
export default __webpack_public_path__ + "static/media/fail.7bd17a2c1c73c5a0d162577d8a32af95.svg";
export { ForwardRef as ReactComponent };